import axios from "axios";
import { useState } from "react";
import { Container, Form, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { root_url } from "../setting";
const PersonalRecord = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const onSubmit = (data) => {
    const { holdRound, backNo, name } = data;
    // console.log(holdRound);
    // console.log(backNo);
    // console.log(name);
    axios({
      method: "post",
      url: `${root_url}/api/ranking/person`,
      data: { holdRound: parseInt(holdRound), backNo, runnerName: name },
    })
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          setDataList(res.data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.data.errorMessage);
        }
      });
  };
  return (
    <Container>
      <h1 className="mt-3 mb-5">개인 기록 조회</h1>
      <h5 className="mb-5">
        2024년도 23회 대회까지 개인기록(하프코스, 미니코스)을 조회할 수
        있습니다. 2021년도 20회 대회는 언택트 순위를 통해 확인할 수 있습니다.
      </h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group>
          <Form.Label>회차</Form.Label>
          <select className="custom-select" {...register("holdRound")}>
            <option value="2024">2024년 23회</option>
            <option value="2023">2023년 22회</option>
            <option value="2022">2022년 21회</option>
            <option value="2021">2021년 20회</option>
            <option value="2019">2019년 19회</option>
            <option value="2018">2018년 18회</option>
            <option value="2017">2017년 17회</option>
            <option value="2016">2016년 16회</option>
            <option value="2015">2015년 15회</option>
            <option value="2014">2014년 14회</option>
            <option value="2013">2013년 13회</option>
            <option value="2012">2012년 12회</option>
            <option value="2011">2011년 11회</option>
            <option value="2010">2010년 10회</option>
            <option value="2009">2009년 9회</option>
            <option value="2008">2008년 8회</option>
            <option value="2007">2007년 7회</option>
            <option value="2006">2006년 6회</option>
            <option value="2005">2005년 5회</option>
            <option value="2004">2004년 4회</option>
            <option value="2003">2003년 3회</option>
            <option value="2002">2002년 2회</option>
            <option value="2001">2001년 1회</option>
          </select>
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>배번호</Form.Label>
          <input
            type="number"
            className="form-in-class"
            placeholder="배번호"
            {...register("backNo", {
              required: true,
              pattern: /^[0-9]/g,
            })}
          />
          {errors.backNo && (
            <span
              className="position-absolute"
              style={{ fontSize: "0.8rem", color: "red" }}
            >
              (필수)배번호를 입력해주세요
            </span>
          )}
        </Form.Group>
        <Form.Group className="mt-3 mb-5">
          <Form.Label>이름</Form.Label>
          <input
            type="text"
            className="form-in-class"
            placeholder="홍길동"
            {...register("name", {
              required: true,
            })}
          />
          {errors.name && (
            <span
              className="position-absolute"
              style={{ fontSize: "0.8rem", color: "red" }}
            >
              (필수)이름을 입력해주세요
            </span>
          )}
        </Form.Group>
        <input
          type="submit"
          className="bg-custom-color p-2 ps-3 pe-3 rounded text-white mb-5"
          style={{ border: "none" }}
          value="조회하기"
        />
      </form>
      {!isLoading &&
        (dataList.length === 0 ? (
          <div>결과가 없습니다.</div>
        ) : (
          <div style={{ overflowX: "scroll" }}>
            <Table
              style={{
                fontSize: "0.9rem",
                lineHeight: "2rem",
                marginBottom: "5rem",
                minWidth: "600px",
              }}
            >
              <thead>
                <tr>
                  <td style={{ width: "10%" }}>이름</td>
                  <td style={{ width: "10%" }}>배번</td>
                  <td style={{ width: "8%" }}>성별</td>
                  <td style={{ width: "10%" }}>연대</td>
                  <td>출발 시간</td>
                  <td>완주 시간</td>
                  <td>소요 시간</td>
                  <td style={{ width: "8%" }}>연대별</td>
                  <td style={{ width: "8%" }}>종합</td>
                </tr>
              </thead>
              <tbody>
                {dataList.map((data, key) => {
                  return (
                    <tr key={data.backNo}>
                      <td>{data.runnerName}</td>
                      <td>{data.backNo}</td>
                      <td>{data.gender === "M" ? "남자" : "여자"}</td>
                      <td>{data.ageType}대</td>
                      <td>{data.startTime}</td>
                      <td>{data.finishTime}</td>
                      <td>{data.elapseTime}</td>
                      <td>{data.ageRank}</td>
                      <td>{data.totalRank}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ))}
    </Container>
  );
};

export default PersonalRecord;
